import { Component, Input, OnInit } from "@angular/core";
import { LabelsInsufficientInterface } from "src/app/interfaces/labels.interface";
import { SetEventInterface } from "src/app/interfaces/tagging.interface";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { TaggingService } from "src/app/services/tagging.service";

/**
 * Component DialogComponent.
 *
 * @export
 * @class DialogComponent
 */
@Component({
    selector: "dialog-insufficient-funds",
    templateUrl: "./dialog-insufficient-funds.component.html",
    styleUrls: ["./dialog-insufficient-funds.component.scss"],
    standalone: false
})
export class InsufficientFundsDialog implements OnInit {
  public data: any;

  public activeBtn: boolean = true;

  @Input() labels: LabelsInsufficientInterface;

  constructor(
    private bss: BottomSheetService,
    private taggingService: TaggingService
  ) {}

  closeDialog(): void {
    this.bss.hide();
  }

  ngOnInit(): void {
    if (this.data) {
      this.labels = this.data.labels;
    }

    const action: SetEventInterface = {
      event: "payments",
      categoria: "error",
      accion: "recarga_celular/detalle",
      etiqueta: `${this.data?.labels?.dialogLabel?.replace(/ /g, "_")}`,
      canalBanco: "supermovil",
      userID: "",
    };

    this.taggingService.setEvent(action);
  }
}
